"use strict";

import React from "react";
import classNames from "classnames";

export default class SearchWidget extends React.Component {
    constructor(props){
        super(props);

        var { onSearch, onChange, onClear } = props;
        if(onSearch) {
            this.onSearch = onSearch;
        }

        if(onClear) {
            this.onClear = onClear;
        }

        if(onChange) {
            this.onChange = onChange;
        }

        this.state = {
            currentSearch: "",
            active: false
        };
    }

    onSearch(searchString){}
    onChange(searchString){}
    onClear() {}

    render(){
        return(
            <div className = {classNames("search-widget", "editor", this.props.className, this.state.active? "search-active":"")}>

                <div className="icon-magnifier icon" onClick={()=>this._handleMagnifierClick()} />
                <input type="text" className= {classNames("search-text", "edit-text")} placeholder={this.props.placeholder}
                    value={this.state.currentSearch}
                    onChange={message => this._handleChangeText(message)}
                    onKeyPress={message => this._handleBtnDown(message)} />
                {this.state.active?(<div className="icon-cancel icon" onClick={() => this._handleCancelClick()} />):""}
            </div>
        );
    }

    _handleMagnifierClick() {
        this.onSearch(this.state.currentSearch);
    }

    _handleChangeText(changeEvent) {
        this.setState({
            currentSearch: changeEvent.target.value,
            active:changeEvent.target.value.length > 0
        });
        this.onChange(changeEvent.target.value);
        if(changeEvent.target.value.length == 0){
            this.onClear();
        }
    }

    _handleBtnDown(keyEvent) {
        if(keyEvent.key === 'Enter') { // Enter pressed
            keyEvent.stopPropagation();
            if(this.state.currentSearch != "") {
                this.onSearch(this.state.currentSearch);
            }
        }
    }

    _handleCancelClick() {
        this.setState({
            currentSearch: "",
            active: false
        });
        this.onClear();
    }

}

